//
//
//
//
//
//
//
//
//

import QrCode from 'vue-qr'
import Model from '@/models/create'
export default {
    components: {
        QrCode
    },
    data() {
        return {
            source: '',
            formData: {
                busNo: '',
                parkNo: '',
                freeDuration: '',
                timestanp: new Date().getTime()
            },
            minute: 0,
            hour: 0,
            day: 0,
            codeSize: 0
        }
    },
    methods: {
        async getCodeParams() {
            const { busNo, parkNo, freeDuration } = this.$route.params;
            let { data } = await Model.getCodeParams({
                busNo,
                parkNo
            });
            if(data.success) {
                const { list } = data;
                this.formData.busNo = busNo;
                this.formData.parkNo = parkNo;
                this.formData.freeDuration = list.freeDuration;
                this.formData.timestanp = list.updateTime;
                this.createCode();
                this.timeoutResearch();
            }
        },
        async setCodeFlashTime() {
            const { busNo, parkNo } = this.formData;
            const { data } = await Model.setCodeFlashTime({
                busNo,
                parkNo
            })
            data.success ? this.$message.success('操作成功') : this.$message.error('刷新二维码失败');
        },
        timeoutResearch() {
            setTimeout(() => {
                this.getCodeParams();
            }, 5000)
        },
        createCode() {
            const { busNo, parkNo, freeDuration, timestanp } = this.formData;
            this.source = `${location.origin}/mobile/ticket/${busNo}/${parkNo}/${freeDuration}/${timestanp}`
        },
        print() {
            window.print();
        }
    },
    created() {
        this.getCodeParams();
        const minute = 60 * 1000;
        const hour = 60 * minute;
        const day = 24 * hour;
        this.minute = minute;
        this.hour = hour;
        this.day = day;
    },
    mounted() {
        const winWidth = document.body.clientWidth;
        if(this.$isMobile) {
            this.codeSize = winWidth;
        }else {
            this.codeSize = 600;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/code/TicketCode.vue